const config = {
  // requestUrl: 'http://localhost:1500/prod-api/', //动态域名所在地址
  //  requestUrl: 'http://localhost:1500/dev-api/', //动态域名所在地址
  //requestUrl: 'http://192.168.43.221:1500/dev-api/', //动态域名所在地址
  //requestUrl: 'http://192.168.0.7:1500/dev-api/', //动态域名所在地址
  //requestUrl: 'http://10.0.237.140:1500/dev-api/', //动态域名所在地址
  requestUrl: 'https://pos.cmaotai.com/MtAPI/prod-api/', //动态域名所在地址
  // requestUrl: 'https://localhost/MtAPI/prod-api/', //动态域名所在地址
  indexPath:'',
  webTitle:"销售公司驻外填报助手",
  appID:"paperPoll"
}
export default config
 


// WEBPACK FOOTER //
// ./src/config.js